// extracted by mini-css-extract-plugin
export default {"spinner":"logged-out-route_spinner__VPpT3"};